import Locations from './Locations';
import './Locations.scss';

export default Locations;
